module.exports = __webpack_public_path__ + "img/4.d9c8e4c4.png";